import React from 'react';

export const useSelectRow = <T extends { [x: string]: any }>(
  dataSource: T[],
  key: string,
) => {
  const [selectedRowKeys, setSelectedRowKeys] = React.useState<string[]>([]);
  let isAllSelect =
    selectedRowKeys.length > 0 && selectedRowKeys.length == dataSource.length;
  const toggleSelectRowKeys = () => {
    if (isAllSelect) {
      setSelectedRowKeys([]);
    } else {
      setSelectedRowKeys(dataSource.map((item) => item[key]));
    }
  };
  return {
    selectedRowKeys,
    toggleSelectRowKeys: toggleSelectRowKeys,
    isAllSelect: isAllSelect,
    setSelectedRowKeys,
  };
};
